import { pdfjs } from "react-pdf";

// https://github.com/wojtekmaj/react-pdf/tree/main/packages/react-pdf#import-worker-recommended
export const initPdfWorker = () => {
  const workerSrc = new URL(
    // Legacy bundle keeps JPEG2000/JBIG2 decoders required by plan PDFs (ADR 0009).
    "pdfjs-dist/legacy/build/pdf.worker.min.mjs",
    import.meta.url
  ).toString();

  pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;
};
